import React from "react";
import { Row } from "antd";
import LabelValue from "../../../../common/LabelValue";
import MainHeader from "../../../../common/MainHeader";

export default function PersonalInfo({ identification, isFull }) {
  return (
    <div>
      <MainHeader title={"Personal Info"} />
      <Row gutter={[8,8]} justify={"start"} style={{ marginTop: "10px" }}>
        <LabelValue
          // label="Ethnicity/Nationality"
          isFull={isFull}
          label="Nationality"
          value={identification?.nationality || "N/A"}
        />
        <LabelValue
          isFull={isFull}
          label="Hair"
          value={identification?.hair || "N/A"}
        />
        <LabelValue
          isFull={isFull}
          label="Eyes"
          value={identification?.eyes || "N/A"}
        />
        <LabelValue
          isFull={isFull}
          label="Weight"
          value={
            identification?.weight ? identification?.weight + " lbs" : "N/A"
          }
        />
        <LabelValue
          isFull={true}
          label="Height"
          value={
            identification?.height ? identification?.height + " in" : "N/A"
          }
        />
      </Row>
    </div>
  );
}
